import React from 'react';

export default function Benchmarking() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop:'2rem' }}>
      <h2>Benchmarking</h2>
    </div>
  );
}
